export default {
    loading: false,
    error: null,
    postalCodeZones: [],
}
